
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.1663 3.66669H5.66634C5.18011 3.66669 4.7138 3.85984 4.36998 4.20366C4.02616 4.54747 3.83301 5.01379 3.83301 5.50002V18.3334C3.83301 18.8196 4.02616 19.2859 4.36998 19.6297C4.7138 19.9735 5.18011 20.1667 5.66634 20.1667H18.4997C18.9859 20.1667 19.4522 19.9735 19.796 19.6297C20.1399 19.2859 20.333 18.8196 20.333 18.3334V12.8334","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.333 6.41665L21.708 5.04165C22.0727 4.67698 22.2776 4.18238 22.2776 3.66665C22.2776 3.15093 22.0727 2.65632 21.708 2.29165C21.3433 1.92698 20.8487 1.72211 20.333 1.72211C19.8173 1.72211 19.3227 1.92698 18.958 2.29165L17.583 3.66665M20.333 6.41665L12.9997 13.75L9.33301 14.6666L10.2497 11L17.583 3.66665M20.333 6.41665L17.583 3.66665","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    